import { Conditional } from './Conditional';
export function isLinkConditional(link) {
    return link !== null && typeof link === 'object' && link instanceof Conditional;
}
export {
    isLinkConditional as isConditional
};
export default isLinkConditional;    //# sourceMappingURL=isConditional.js.map
